import { differenceInDays, isAfter, subMonths } from "date-fns";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl78branchesValidationSchema = () => {
  const { t } = useTranslation();
  return yup
    .object()
    .shape({
      d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardDate: yup
        .date()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
      usageFromDate: yup
        .date()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
      usageToDate: yup
        .date()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
      fudocShortEconomicData: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      // από το backend (OverlengthFiscalYearExceptions), όχι πεδία της φόρμας
      allowOverlengthFiscalYear: yup.boolean().nullable(),
      maxUsageMonths: yup.number().nullable(),
      totalActive: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^[0-9]*(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      businessCircle: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^(-)?[0-9]+(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      employees: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .matches(
          /^[0-9]*(\.)?[0-9]{0,2}$/,
          `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        ),
      assets: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      reserves: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      requirements: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      prepayments: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      equityTotal: yup.string().matches(/^(-)?[0-9]+(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      obligationsTotal: yup.string().matches(/^[0-9]*(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      resultsNoTax: yup.string().matches(/^(-)?[0-9]+(\.)?[0-9]{0,2}$/, {
        message: `${t("Το πεδίο πρέπει να είναι αριθμός")}. ${t("Το ποσό πρέπει να έχει μέχρι δύο δεκαδικά ψηφία με τελεία (πχ. 9999.99)")}.`,
        excludeEmptyString: true,
      }),
      foreignRegistryProtocol: yup.string().when(
        "isNonEuForeignBranch",
        {
          is: false,
          then: (schema) =>
            schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          otherwise: (schema) => schema.nullable(),
        },
      ),

      foreignRegistryDate: yup.date().when(
        "isNonEuForeignBranch",
        {
          is: false,
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .min(
                yup.ref("usageToDate"),
                t(
                  "Η ημερομηνία πρέπει να είναι μεταγενέστερη του Ισολογισμού Χρήσης.",
                ),
              ),
          otherwise: (schema) =>
            schema
              .nullable()
              .min(
                yup.ref("usageToDate"),
                t(
                  "Η ημερομηνία πρέπει να είναι μεταγενέστερη του Ισολογισμού Χρήσης.",
                ),
              ),
        },
      ),

      foreignRegistryURL: yup.string().when(
        "isNonEuForeignBranch",
        {
          is: false,
          then: (schema) =>
            schema
              .required(t("Το πεδίο είναι υποχρεωτικό"))
              .matches(
                /^(http:\/\/|https:\/\/)/,
                t("Το URL πρέπει να ξεκινάει με http:// ή https://"),
              ),
          otherwise: (schema) =>
            schema
              .nullable()
              .matches(
                /^(http:\/\/|https:\/\/)/,
                t("Το URL πρέπει να ξεκινάει με http:// ή https://"),
              ),
        },
      ),
    })
    .test(
      "balance dates must me max year apart",
      t(
        "Ελέγξτε τις ημερομηνίες χρήσης. Η ημερομηνία έναρξης χρήσης πρέπει να απέχει το πολύ ένα χρόνο από την ημερομηνία λήξης.",
      ),
      function (value) {
        const { usageFromDate, usageToDate, allowOverlengthFiscalYear, maxUsageMonths } = value;
        if (!usageFromDate || !usageToDate) return false;
        // εγκεκριμένη υπερδωδεκάμηνη χρήση έως maxUsageMonths μήνες (ελέγχεται και στο backend)
        if (allowOverlengthFiscalYear && maxUsageMonths) {
          if (differenceInDays(usageToDate, usageFromDate) < 0) {
            return this.createError({
              message: t(
                "Ελέγξτε τις ημερομηνίες χρήσης. Η ημερομηνία έναρξης χρήσης δεν μπορεί να είναι μεταγενέστερη της λήξης.",
              ),
            });
          }
          return (
            isAfter(usageFromDate, subMonths(usageToDate, maxUsageMonths)) ||
            this.createError({
              message: t(
                "Ελέγξτε τις ημερομηνίες χρήσης. Η ημερομηνία έναρξης χρήσης πρέπει να απέχει το πολύ 18 μήνες από την ημερομηνία λήξης.",
              ),
            })
          );
        }
        return (
          0 <= differenceInDays(usageToDate, usageFromDate) &&
          differenceInDays(usageToDate, usageFromDate) <= 365
        );
      },
    );
};
